import { useParams } from 'react-router-dom';
import NotesSubjectView from '../components/NotesSubjectView';
// key : changer de sujet repart d'une page vierge (pas de résultats du sujet précédent)
export default function NotesSubject() { const { id } = useParams(); return <NotesSubjectView key={id} />; }
